
import { List, Loader } from './styles';

import LayerItem from '../LayerItem';

import Skeleton from '@material-ui/lab/Skeleton';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';

/**
 * reorder
 * 
 * @param {array} list 
 * @param {number} startIndex 
 * @param {number} endIndex 
 * @returns 
 */
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * LayerList
 * 
 * @param {object} appContext
 * @param {boolean} setScrolled
 * @param {array} scrolled
 * @param {*} props
 * 
 * @returns 
 */
export const LayerList = ({ appContext, setScrolled, scrolled, ...props }) => {
  const { layers, setLayers, loadingMap } = useMap();

  const [menuActionActived, setMenuActionActived] = useState(null);
  const [currentLayersLength, setCurrentLayersLength] = useState(layers.length);

 
  
  /**
   * Observa se houve scrolling para fechar o menu de ações.
   */
  useEffect(() => {
    if (scrolled) {      
      setMenuActionActived(false);      
    }  
  }, [scrolled]);



  useEffect(() => {
    if (layers.length !== currentLayersLength) {      
      setCurrentLayersLength(layers.length);
    }
  }, [layers, layers.length, currentLayersLength]);


  const onDragEnd = (result) => {
    // Solto fora da lista, pode ser uma opção para exlusão
    if (!result.destination) {
      return;
    }

    const items = reorder(
      layers,
      result.source.index,
      result.destination.index
    );

    setLayers(items, true);
  };

  /**
   * Fecha menu de ações quando iniciar reposicionamento 
   * de camada com 'arrasto'
   */
  const onDragStart = () => {
    setMenuActionActived(false);
  };


  return loadingMap ? (
    <Loader>
      <div className="layer-loader">
        <Skeleton variant="text" />
        <Skeleton variant="text" width={100} />
      </div>
      <div className="layer-loader">
        <Skeleton variant="text" />
        <Skeleton variant="text" width={100} />
      </div>
      <div className="layer-loader">
        <Skeleton variant="text" />
        <Skeleton variant="text" width={100} />
      </div>
      <div className="layer-loader">
        <Skeleton variant="text" />
        <Skeleton variant="text" width={100} />
      </div>
    </Loader>
  ) : layers && layers.length ? (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <List {...provided.droppableProps} ref={provided.innerRef}>
            <ul>
            {layers.map((item, index) => (
              <li key={item.id}>
               <LayerItem
                  key={item.id}
                  layer={item}
                  index={index}
                  appContext={appContext}
                  setMenuActionActived={setMenuActionActived}
                  menuActionActived={menuActionActived}
                />
              </li>
            ))}
            </ul>
            {provided.placeholder}
          </List>
        )}
      </Droppable>
    </DragDropContext>
  ) : (
    'Sem camadas'
  );
};

export default LayerList;
